import { CCol } from "@coreui/react"
import PropTypes from "prop-types"
import React from "react"
import { numberFormat } from "utils"

import CMSTypography, {
  StandardTypographyTypes
} from "../typography/CMSTypography"

function LinearList({ text, value, onClickHandler }) {
  return (
    <CCol
      xs="12"
      className="mt-2 p-0 d-flex justify-content-between align-items-center cursor-pointer"
      tabIndex={0}
      onClick={() => onClickHandler([text])}
    >
      {/* <img src={img} alt="icon" width={30} height={30} /> */}
      <span className={`text-start ${value === "0" ? "w-100" : ""}`}>
        <CMSTypography type={StandardTypographyTypes.cardContent}>
          {text}
        </CMSTypography>
      </span>
      <span
        className={`${value === "0" ? "" : "w-50"}  text-right`}
        data-testid={text}
      >
        <CMSTypography type={StandardTypographyTypes.cardContent}>
          {numberFormat(value)}
        </CMSTypography>
      </span>
    </CCol>
  )
}

LinearList.propTypes = {
  img: PropTypes.string,
  text: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
  onClickHandler: PropTypes.func
}

export default LinearList
